angular.module('picmonicng').filter('timeFormat', [
  function () {
    return function (input) {
      if (input) {
        var min = '' + Math.floor(input / 60);
        var sec = '' + Math.floor(input % 60);

        sec = sec.length < 2 ? '0' + sec : sec;

        return min + ':' + sec;
      } else {
        return '0:00';
      }
    };
  },
]);
